import { Overlay } from '../overlay';

export interface PositionStrategy {
	attach(overlay: Overlay): void;
	apply(): void;
	detach(): void;
	dispose(): void;
}
